import { z } from "zod";

const runtimeFields = {
  tenantId: z.uuid(),
  origins: z.array(z.url()).min(1).max(1000),
  apiUrl: z.url(),
};

const RuntimeSchema = z.discriminatedUnion("version", [
  z.object({ version: z.literal(1), ...runtimeFields }).strict(),
  z
    .object({
      version: z.literal(2),
      ...runtimeFields,
      defaultLanguage: z.enum(["ar", "en"]),
    })
    .strict(),
]);

export function runtimeDefaultLanguage(runtime: unknown) {
  if (runtime === undefined) return undefined;
  const parsed = RuntimeSchema.safeParse(runtime);
  return parsed.success && parsed.data.version === 2
    ? parsed.data.defaultLanguage
    : undefined;
}

export function deploymentApiUrl({
  origin,
  runtime,
  required,
  mapped,
  fallback,
}: {
  origin: string;
  runtime: unknown;
  required: boolean;
  mapped?: string;
  fallback: string;
}) {
  if (runtime !== undefined || required) {
    const parsed = RuntimeSchema.safeParse(runtime);
    if (
      !parsed.success ||
      parsed.data.apiUrl !== origin ||
      !parsed.data.origins.includes(origin)
    )
      throw new Error("TENANT_RUNTIME_CONFIGURATION_UNAVAILABLE");
    return parsed.data.apiUrl;
  }
  return mapped || fallback;
}
